import { Theme, useMediaQuery } from '@mui/material';
import MuiDrawer, { DrawerProps as MuiDrawerProps } from '@mui/material/Drawer';
import { HIDE_TOP_NAV_OPTIONS, PORTAL_CONFIG } from 'component/layoutComponents/topNav/topNav';
import {
  SECONDARY_MENU_HEIGHT,
  TOP_NAV_HEIGHT,
  TOP_NAV_MOBILE_HEIGHT,
  TOP_NAV_Z_INDEX,
} from 'component/layoutComponents/topNav/topNav.style';
import React, { useEffect } from 'react';

export interface DrawerProps extends MuiDrawerProps {
  isUnderTopNav?: boolean;
  isOpenSubmenu?: boolean;
  handleWidgetIndex?: (arg: boolean) => void;
}

const DRAWER_MAX_WIDTH = 522;

const calculateDrawerHeight = (top: string | Record<string, string>) => {
  if (typeof top === 'string') return `calc(100% - ${top})`;

  const height: typeof top = {};
  for (const breakpoint in top) {
    height[breakpoint] = `calc(100% - ${top[breakpoint]})`;
  }

  return height;
};

const Drawer = ({ isUnderTopNav = true, isOpenSubmenu = false, handleWidgetIndex, ...props }: DrawerProps) => {
  const { hideTopNav } = JSON.parse(sessionStorage.getItem(PORTAL_CONFIG) || '{}');
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  const isHidePrimaryTopNav = [HIDE_TOP_NAV_OPTIONS.TRUE, HIDE_TOP_NAV_OPTIONS.PRIMARY].includes(hideTopNav);
  const topNavHeight = isHidePrimaryTopNav ? 0 : (isOpenSubmenu && lgUp ? (TOP_NAV_HEIGHT + SECONDARY_MENU_HEIGHT) : TOP_NAV_HEIGHT);

  const drawerSx = isUnderTopNav ? { zIndex: TOP_NAV_Z_INDEX - 1, ...props.sx } : props.sx;
  const drawerTop = isUnderTopNav ? { xs: `${TOP_NAV_MOBILE_HEIGHT}px`, md: `${topNavHeight}px` } : '0px';
  const paperSx = {
    width: '90%',
    maxWidth: DRAWER_MAX_WIDTH,
    bgcolor: 'grey.100',
    top: drawerTop,
    height: calculateDrawerHeight(drawerTop),
    ...props.PaperProps?.sx,
  };

  useEffect(() => {
    if (!handleWidgetIndex) return;
    handleWidgetIndex(!!props?.open);
  }, [props.open]);

  return (
    <MuiDrawer
      anchor="right"
      disableScrollLock
      {...props}
      sx={drawerSx}
      ModalProps={{
        disableRestoreFocus: true,
        disableEnforceFocus: true,
      }}
      PaperProps={{
        sx: paperSx,
        ...props.PaperProps,
      }}
      className={`uptime-drawer ${props.className || ''}`}
    />
  );
};

export default Drawer;
